
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ps/plans-pricing",
      function () {
        return require("private-next-pages/ps/plans-pricing/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ps/plans-pricing"])
      });
    }
  